export const MATERIALS = {
  aluminium: {
    label: "Aluminium",
    label_en: "Aluminium",
    designations: ["2017A", "2024", "5052", "5083", "5754", "6060", "6061", "6082", "7020", "7049", "7050", "7075"],
  },
  acier: {
    label: "Acier",
    label_en: "Steel",
    designations: ["S235JR", "S355J2", "C45", "C35", "42CrMo4", "34CrNiMo6", "16MnCr5", "100Cr6", "XC48", "25CrMo4", "40NiCrMo7"],
  },
  inox: {
    label: "Inox",
    label_en: "Stainless steel",
    designations: ["304 (A2)", "304L", "316 (A4)", "316L", "316Ti", "321", "347", "410", "420", "430", "17-4PH", "15-5PH", "Duplex 2205"],
  },
  titane: {
    label: "Titane",
    label_en: "Titanium",
    designations: ["Grade 1 (TA1)", "Grade 2 (TA2)", "Grade 5 (TA6V / Ti-6Al-4V)", "Grade 7", "Grade 9", "Grade 23 (Ti-6Al-4V ELI)"],
  },
  cuivre: {
    label: "Cuivre",
    label_en: "Copper",
    designations: ["Cu-ETP (C11000)", "Cu-OF (C10200)", "Cu-DHP (C12200)", "CuBe2 (C17200)", "CuCrZr"],
  },
  laiton: {
    label: "Laiton",
    label_en: "Brass",
    designations: ["CuZn36 (C27000)", "CuZn37 (C27200)", "CuZn39Pb3 (C38500)", "CuZn40 (C28000)"],
  },
  bronze: {
    label: "Bronze",
    label_en: "Bronze",
    designations: ["CuSn8 (C52100)", "CuSn12 (C90700)", "CuAl10Ni (C63000)", "CuAl10Fe3"],
  },
  plastique: {
    label: "Plastique / Polymère",
    label_en: "Plastic / Polymer",
    designations: ["POM (Delrin)", "PEEK", "PA6 (Nylon)", "PA66", "PTFE (Teflon)", "PVC", "PMMA (Plexiglas)", "PE-HD", "PP", "Ertalon", "Sustarin"],
  },
  inconel: {
    label: "Inconel / Superalliage",
    label_en: "Inconel / Superalloy",
    designations: ["Inconel 600", "Inconel 625", "Inconel 718", "Hastelloy C276", "Monel 400", "Waspaloy"],
  },
  autre: {
    label: "Autre",
    label_en: "Other",
    designations: ["Préciser dans les notes"],
  },
};

// Surface treatments with FR/EN pairs and a flag for "colored" ones needing RAL
export const SURFACE_TREATMENTS = [
  { fr: "Aucun", en: "None", color: false },
  { fr: "Anodisation (naturelle)", en: "Anodising (natural)", color: false },
  { fr: "Anodisation dure", en: "Hard anodising", color: false },
  { fr: "Anodisation colorée", en: "Colour anodising", color: true },
  { fr: "Alodine / Chromatation", en: "Alodine / Chromating", color: false },
  { fr: "Chromage dur", en: "Hard chrome plating", color: false },
  { fr: "Nickelage chimique (NiP)", en: "Electroless nickel (NiP)", color: false },
  { fr: "Nickelage électrolytique", en: "Electrolytic nickel plating", color: false },
  { fr: "Zinc (électrozingué)", en: "Zinc (electroplated)", color: false },
  { fr: "Zinc lamellaire", en: "Zinc flake coating", color: false },
  { fr: "Cadmiage", en: "Cadmium plating", color: false },
  { fr: "Passivation", en: "Passivation", color: false },
  { fr: "Peinture RAL", en: "RAL paint", color: true },
  { fr: "Peinture poudre (thermolaquage)", en: "Powder coating", color: true },
  { fr: "Sablage / Grenaillage", en: "Sandblasting / Shot blasting", color: false },
  { fr: "Polissage miroir", en: "Mirror polishing", color: false },
  { fr: "Brunissage", en: "Browning / Bluing", color: false },
  { fr: "Phosphatation", en: "Phosphating", color: false },
  { fr: "DLC (Diamond-Like Carbon)", en: "DLC (Diamond-Like Carbon)", color: false },
  { fr: "Nitruration", en: "Nitriding", color: false },
  { fr: "Autre (préciser)", en: "Other (specify)", color: false },
];

export const TOLERANCE_CLASSES = [
  { fr: "Standard (IT10-IT12)", en: "Standard (IT10-IT12)" },
  { fr: "Moyenne (IT8-IT9)", en: "Medium (IT8-IT9)" },
  { fr: "Précise (IT6-IT7)", en: "Tight (IT6-IT7)" },
  { fr: "Très précise (IT5-IT6)", en: "Very tight (IT5-IT6)" },
  { fr: "Ultra-précise (< IT5)", en: "Ultra tight (< IT5)" },
  { fr: "Selon plan", en: "As per drawing" },
];

export const MANUFACTURING_PROCESSES = [
  { fr: "Usinage CNC (fraisage)", en: "CNC machining (milling)" },
  { fr: "Tournage CNC", en: "CNC turning" },
  { fr: "Usinage 5 axes", en: "5-axis machining" },
  { fr: "Découpe laser", en: "Laser cutting" },
  { fr: "Découpe jet d'eau", en: "Waterjet cutting" },
  { fr: "Découpe plasma", en: "Plasma cutting" },
  { fr: "Tôlerie / Pliage", en: "Sheet metal / Bending" },
  { fr: "Soudure TIG", en: "TIG welding" },
  { fr: "Soudure MIG/MAG", en: "MIG/MAG welding" },
  { fr: "Soudure laser", en: "Laser welding" },
  { fr: "Impression 3D métal (SLM/DMLS)", en: "Metal 3D printing (SLM/DMLS)" },
  { fr: "Impression 3D plastique (FDM/SLS)", en: "Plastic 3D printing (FDM/SLS)" },
  { fr: "Fonderie / Moulage", en: "Casting / Moulding" },
  { fr: "Forge / Matriçage", en: "Forging / Drop forging" },
  { fr: "Électroérosion (EDM)", en: "EDM (Electrical Discharge Machining)" },
  { fr: "Rectification", en: "Grinding" },
  { fr: "Décolletage", en: "Bar turning" },
  { fr: "Assemblage", en: "Assembly" },
  { fr: "Autre (préciser)", en: "Other (specify)" },
];

export const CERTIFICATIONS = [
  { fr: "ISO 9001", en: "ISO 9001" },
  { fr: "EN 9100 (Aéronautique)", en: "EN 9100 (Aerospace)" },
  { fr: "ISO 13485 (Médical)", en: "ISO 13485 (Medical)" },
  { fr: "NADCAP", en: "NADCAP" },
  { fr: "ISO 14001", en: "ISO 14001" },
  { fr: "IATF 16949 (Automobile)", en: "IATF 16949 (Automotive)" },
  { fr: "Certificat matière 3.1", en: "Material certificate 3.1" },
  { fr: "Certificat matière 3.2", en: "Material certificate 3.2" },
  { fr: "Rapport dimensionnel", en: "Dimensional report" },
  { fr: "Aucune exigence particulière", en: "No specific requirement" },
];

// Helper: translate a stored FR value to current lang
export function translateTerm(frValue, list, lang = 'fr') {
  if (!frValue) return '';
  const entry = list.find(x => (x.fr || x) === frValue);
  if (!entry) return frValue;
  if (typeof entry === 'string') return entry;
  return lang === 'en' ? (entry.en || entry.fr) : entry.fr;
}

export function translateMaterial(key, lang = 'fr') {
  const m = MATERIALS[key];
  if (!m) return key;
  return lang === 'en' ? (m.label_en || m.label) : m.label;
}

// ── Points particuliers de fabrication (per-part attention flags) ─────────
// Bilingual labels + hint tooltip. `color` maps to SP_CHIP_CLS below.
export const PART_SPECIAL_POINTS = [
  { key: 'filetage_gauche',     fr: 'Filetage gauche',              en: 'Left-hand thread',           color: 'amber',   hint_fr: 'Filetage sens inverse (LH)',        hint_en: 'Left-hand thread (LH)' },
  { key: 'tolerance_serree',    fr: 'Tolérance serrée',             en: 'Tight tolerance',            color: 'rose',    hint_fr: 'ISO IT6 / IT7 ou inférieur',        hint_en: 'ISO IT6/IT7 or tighter' },
  { key: 'traitement_thermique',fr: 'Traitement thermique',         en: 'Heat treatment',             color: 'orange', hint_fr: 'Trempe, revenu, cémentation…',       hint_en: 'Hardening, tempering, case…' },
  { key: 'durete',              fr: 'Dureté requise',               en: 'Required hardness',          color: 'orange', hint_fr: 'Ex. 45-50 HRC',                      hint_en: 'e.g. 45-50 HRC' },
  { key: 'etat_surface',        fr: 'État de surface',              en: 'Surface finish',             color: 'blue',    hint_fr: 'Ra ≤ 1.6 ou spécifique',            hint_en: 'Ra ≤ 1.6 or specific' },
  { key: 'soudure',             fr: 'Soudure',                      en: 'Welding',                    color: 'orange', hint_fr: 'Sécurité, aspect ou test requis',    hint_en: 'Safety / aesthetic / test required' },
  { key: 'cote_critique',       fr: 'Cote critique',                en: 'Critical dimension',         color: 'rose',    hint_fr: 'Cote entourée / à contrôler à 100 %',hint_en: 'Circled / 100 % inspection' },
  { key: 'sens_orientation',    fr: 'Sens / orientation',           en: 'Direction / orientation',    color: 'amber',   hint_fr: 'Sens fibre, marquage orienté',      hint_en: 'Grain direction / marking' },
  { key: 'rugosite',            fr: 'Rugosité contrôlée',           en: 'Roughness controlled',       color: 'blue',    hint_fr: 'Mesure obligatoire',                 hint_en: 'Measurement required' },
  { key: 'controle_100',        fr: 'Contrôle 100 %',               en: '100 % inspection',           color: 'rose',    hint_fr: 'Toutes les pièces contrôlées',       hint_en: 'Every piece inspected' },
  { key: 'ebavurage',           fr: 'Ébavurage · arêtes vives',     en: 'Deburring · sharp edges',    color: 'zinc',    hint_fr: 'Chanfrein 0.5×45° ou dévié',        hint_en: 'Chamfer 0.5×45° or de-edged' },
  { key: 'certificat_matiere',  fr: 'Certificat matière',           en: 'Material certificate',       color: 'emerald', hint_fr: '3.1 / 3.2 EN 10204',                 hint_en: '3.1 / 3.2 EN 10204' },
  { key: 'marquage_tracabilite',fr: 'Marquage traçabilité',         en: 'Traceability marking',       color: 'emerald', hint_fr: 'N° lot, référence',                  hint_en: 'Batch nr, reference' },
  { key: 'autre',               fr: 'Autre',                        en: 'Other',                      color: 'zinc',    hint_fr: 'Précisez dans les Notes ci-dessous', hint_en: 'Specify in Notes below' },
];

// Tailwind class variants for the chips — declared here so both admin and sub
// share the same colour language. Tailwind JIT scans this file too, so the
// arbitrary compound strings below are safe from purge.
export const SP_CHIP_CLS = {
  amber:   { on: 'bg-amber-500/15 text-amber-300 border-amber-500/40',      off: 'bg-zinc-950 text-zinc-500 border-zinc-800 hover:border-amber-500/30 hover:text-amber-400' },
  rose:    { on: 'bg-rose-500/15 text-rose-300 border-rose-500/40',         off: 'bg-zinc-950 text-zinc-500 border-zinc-800 hover:border-rose-500/30 hover:text-rose-400' },
  orange:  { on: 'bg-orange-500/15 text-orange-300 border-orange-500/40',   off: 'bg-zinc-950 text-zinc-500 border-zinc-800 hover:border-orange-500/30 hover:text-orange-400' },
  blue:    { on: 'bg-blue-500/15 text-blue-300 border-blue-500/40',         off: 'bg-zinc-950 text-zinc-500 border-zinc-800 hover:border-blue-500/30 hover:text-blue-400' },
  emerald: { on: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/40',off: 'bg-zinc-950 text-zinc-500 border-zinc-800 hover:border-emerald-500/30 hover:text-emerald-400' },
  zinc:    { on: 'bg-zinc-700/40 text-zinc-200 border-zinc-500/40',         off: 'bg-zinc-950 text-zinc-500 border-zinc-800 hover:border-zinc-600 hover:text-zinc-300' },
};

// Helper: get the bilingual label + tooltip for a special-point key
export function getSpecialPoint(key, lang = 'fr') {
  const sp = PART_SPECIAL_POINTS.find(x => x.key === key);
  if (!sp) return null;
  return {
    key: sp.key,
    label: lang === 'en' ? sp.en : sp.fr,
    hint:  lang === 'en' ? sp.hint_en : sp.hint_fr,
    color: sp.color,
    cls:   SP_CHIP_CLS[sp.color] || SP_CHIP_CLS.zinc,
  };
}

